//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Reflux from 'reflux'
import Store from '../../store/store'
import Upload from './steps/upload'
import HeaderSteps from './headersteps'
import Download from './steps/download'
import BaseComponent from '../base'
import api from "../../source/api";
import NavCashregisterList from "./NavCashregisterList";
import {Link} from "react-router-dom";
import i18 from "../../i18";
import NotificationSystem from "react-notification-system";

class Cashregister extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            hidemenu: false,
            showNavCashregisterList: false,
            files: [],
            totalSummarization: [],
            summarization: [],
            userconfigs: {},
            navCashregisters: null,
            steps: {
                next: 2,
                current: 1,
                data: {}
            },
            company_id: props.location.match.params.id,
            company: null
        }
        this.store = Store
    }

    notifySuccess = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'success',
            position: 'tc',
            autoDismiss: 10
        })
    };

    notifyError = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'error',
            position: 'tc',
            autoDismiss: 10
        })
    };

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'cashregister/init?company_id=' + this.state.company_id}, true).then((response) => {
            this.setState({
                userconfigs: response.data.userconfigs || {},
                company: response.data.company,
                onlineszamlaToken: response.data.onlineszamlaToken,
                navCashregisters: response.data.navCashregisters
            })
        })
    }

    hideStepsMenu = () => {
        this.setState({hidemenu: true})
    }

    setNextStep = () => {
        let steps = this.state.steps;
        steps.current += 1
        steps.next = steps.current + 1
        this.setState({steps: steps});
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
    }

    prevStep = (step) => {
        let steps = this.state.steps;
        steps.current = 1;
        steps.next = 2;
        this.setState({steps: steps});
    }

    setOutputFiles = (data) => {
        this.setState({
            files: data.file,
            totalSummarization: data.totalSummarization,
            summarization: data.summarization,
        })
    }

    switchShowingNavCashregisterList = () => {
        this.setState({
            showNavCashregisterList: !this.state.showNavCashregisterList,
        })
    }


    render() {
        return (
            <section id='cashregister-upload'>
                {!this.state.hidemenu && !this.state.showNavCashregisterList
                    ? <div>
                        <HeaderSteps
                            prevStep={(step) => this.prevStep(step)}
                            currentStep={this.state.steps.current}
                        />
                        <div className='header'>
                            <div className='container'>

                                <h1 className='margin-bottom-50'>Pénztárgépszalagok automatikus könyvelése</h1>

                                <p>
                                    Töltse fel a könyvelt cégtől kapott pénztárszalag XML-eket, ZIP-ben. Válassza ki az Ön által használt könyvelőprogramot, amennyiben először használja az adott modult, kérjük, paraméterezze fel az adott cég Főkönyvi struktúráját.
                                </p>

                                <div className="row" style={{marginBottom: "50px"}}>
                                    <div className="col-md-12">
                                        <div className="pull-left">
                                            <h4 className='text-left'>Kiválasztott cég: {this.state.company ? this.state.company.name : ''} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                                        </div>
                                        <div className="pull-right">
                                            {this.state.company
                                                ? <Link className={this.state.company.onlineszamlaToken ? 'table-green-btn' : 'table-gray-btn'} to={`/company/onlineszamla/${this.state.company.id}`}>Onlineszámla API</Link>
                                                : null
                                            }&nbsp;
                                            <a onClick={() => this.switchShowingNavCashregisterList()} className='table-green-btn'>{i18.CASHREGISTER._navCashregisterTitle}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }


                <div className={this.state.showNavCashregisterList ? '' : 'd-none'}>
                    {this.state.navCashregisters
                        ? <NavCashregisterList
                            navCashregisters={this.state.navCashregisters}
                            company={this.state.company}
                            switchShowingNavCashregisterList={() => this.switchShowingNavCashregisterList()}
                            notifySuccess={(msg) => this.notifySuccess(msg)}
                            notifyError={(msg) => this.notifyError(msg)}
                        />
                        : null
                    }

                </div>
                <div className={this.state.showNavCashregisterList ? 'd-none' : 'upload-body'}>
                    <div className='container'>
                        <div className={this.state.steps.current === 1 ? 'row' : 'd-none'}>
                            <Upload
                                {...this.props}
                                company={this.state.company}
                                userconfigs={this.state.userconfigs}
                                onlineszamlaToken={this.state.onlineszamlaToken}
                                setOutputFiles={(files) => this.setOutputFiles(files)}
                                setNextStep={() => this.setNextStep()}
                                setValue={(name, value, error) => this.setValue(name, value, error)}/>
                        </div>
                        <div className={this.state.steps.current === 2 ? 'row' : 'd-none'}>
                            <Download
                                files={this.state.files}
                                hideStepsMenu={() => this.hideStepsMenu()}
                                summarization={this.state.summarization}
                                totalSummarization={this.state.totalSummarization}
                                {...this.props} />
                        </div>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Cashregister


// WEBPACK FOOTER //
// ./src/components/cashregister/cashregister.js